import { Outlet } from "react-router-dom";
import { Paper } from "@mui/material";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import ScrollToTop, {HandleToTop} from "./components/navigation/ScrollToTop";


function App() {
  return (
    <Paper component="main" sx={{ p: 0 }} className="App" square={false} elevation={0}>
      <Header />
      <Paper className="content" variant="elevation" square={false} elevation={0}>
        <div style={{ paddingTop: `${process.env.REACT_APP_HEADER_SIZE}` }} >
          <Outlet />
        </div>
        <ScrollToTop />
        <HandleToTop scrollHeight={90} />
      </Paper>
      <Footer />
    </Paper>
  );
}

export default App;
 